import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=5a5cb3bc&scoped=true"
import script from "./charts.vue?vue&type=script&lang=js"
export * from "./charts.vue?vue&type=script&lang=js"
import style0 from "./charts.vue?vue&type=style&index=0&id=5a5cb3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5cb3bc",
  null
  
)

export default component.exports